/**
 * Gửi join/leave giống hệt world-watch (Client page): cùng URL + format message.
 * Dashboard của bạn subscribe kênh này (v3/1) để nhận visitor.
 * Message: { type: "join" | "leave", visitor: VisitorInfo }.
 */

const VISITOR_WS_URL =
  process.env.REACT_APP_VISITOR_PIESOCKET_URL ||
  "wss://free.blr2.piesocket.com/v3/1?api_key=esqC7ggDb2Hhf9PGhvHHqCnWRpehUK86uqQ3xsw6&notify_self=1";

export interface VisitorInfo {
  id: string;
  ip: string;
  city: string;
  country: string;
  lat: number;
  lon: number;
  timestamp: number;
}

export interface VisitorSocketMessage {
  type: "join" | "leave";
  visitor: VisitorInfo;
}

export interface GeoResult {
  ip: string;
  city: string;
  country: string;
  lat: number;
  lon: number;
}

const GEO_FALLBACK: GeoResult = {
  ip: "unknown",
  city: "Unknown",
  country: "Unknown",
  lat: 0,
  lon: 0,
};

/** Trên localhost hoặc khi không muốn gọi API bên ngoài (CORS/429 trên production) → trả fallback. */
function isLocalhost(): boolean {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return h === "localhost" || h === "127.0.0.1" || h === "";
}

/**
 * Lấy geo từ trình duyệt. Không gọi ipapi.co/ipwho.is/freeipapi.com từ client (dễ bị CORS/429 trên production).
 * Chỉ dùng navigator.geolocation (nếu user cho phép), sau đó fallback.
 */
export async function getGeoLocation(): Promise<GeoResult> {
  if (isLocalhost()) {
    return { ...GEO_FALLBACK, ip: "localhost" };
  }
  try {
    const pos = await new Promise<GeolocationPosition>((resolve, reject) => {
      if (!navigator.geolocation) return reject(new Error("no geolocation"));
      navigator.geolocation.getCurrentPosition(resolve, reject, { timeout: 5000 });
    });
    const lat = pos.coords.latitude;
    const lon = pos.coords.longitude;
    try {
      const r = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json&accept-language=en`
      );
      if (r.ok) {
        const d = await r.json();
        return {
          ip: "browser-geo",
          city: d.address?.city || d.address?.town || d.address?.state || "Unknown",
          country: d.address?.country || "Unknown",
          lat,
          lon,
        };
      }
    } catch {
      /* ignore */
    }
    return { ...GEO_FALLBACK, lat, lon };
  } catch {
    /* User denied hoặc timeout → dùng fallback, không log */
  }
  return GEO_FALLBACK;
}

export function createVisitorSocket(): WebSocket {
  return new WebSocket(VISITOR_WS_URL);
}

export function generateVisitorId(): string {
  return Math.random().toString(36).substring(2, 10) + Date.now().toString(36);
}
